module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av532-a8782cb0962f6a9cb3dab26d77bb99ad.jpg";